var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalBanner(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 128,
    height: 113,
    viewBox: "0 0 128 113",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M120 147.634c0-.032 24-34.38 24-47.634 0-13.255-10.745-24-24-24s-24 10.745-24 24 24 47.665 24 47.634z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-56 -63)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h240v240H0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#BF2784",
    strokeWidth: 4,
    d: "M85 158h70l-16.736-22H101.92z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#BF2785",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 3,
    d: "M121.5 147.634l-1.642 1.493-.86-.378c-.052-.047-.052-.047-.108-.107l-.069-.08-.032-.042-.026-.037-.059-.083a165.944 165.944 0 0 1-.975-1.416 291.868 291.868 0 0 1-2.733-4.093 308.472 308.472 0 0 1-8.29-13.334C99.061 116.493 94.5 106.173 94.5 100c0-14.083 11.417-25.5 25.5-25.5s25.5 11.417 25.5 25.5c0 4.895-2.877 12.391-7.961 21.955a212.638 212.638 0 0 1-4.245 7.578 312.215 312.215 0 0 1-8.29 13.331 320.19 320.19 0 0 1-3.497 5.223l-.2.292c-.096.217-.096.217.193-.745z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 100,
    r: 12,
    fill: "#FFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalBanner);
export default __webpack_public_path__ + "static/media/LocalBanner.1528e0b92d18cd94d09f36c0664eeff9.svg";
export { ForwardRef as ReactComponent };